module.exports = __webpack_public_path__ + "img/42.7224c03e.svg";